import TimelineCredentials from '@plat/views/event/timelineCredentials/Index'

export default [
  {
    path: '/',
    component: TimelineCredentials,
    name: 'timelineCredentials'
  }
]
